import { NgModule } from '@angular/core';

import { InverterPlanRoutingModule } from './inverter-plan-routing.module';


@NgModule({
  declarations: [

  ],
  imports: [
    InverterPlanRoutingModule
  ]
})
export class InverterPlanModule { }
